import { lazy, useEffect, useState } from "react";

import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import { RoutesPath } from "./route-path";
import Sidebar from "../layout/Sidebar";
import Navbar from "../layout/Navbar";

import ViewGallery from "../pages/gallery/viewGallery/ViewGallery";
import { Constants } from "../utils/constants/Constants";
import { isAuthenticated } from "../helpers/authhelper";
import ErrorElement from "../components/errorElement/ErrorElement";

const Login = lazy(() => import("../pages/login/Login"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const ListUsers = lazy(() => import("../pages/users/listUsers/ListUsers"));
const EditUser = lazy(() => import("../pages/users/editUser/EditUser"));
const ViewUser = lazy(() => import("../pages/users/viewUser/ViewUser"));
const ListIssues = lazy(() => import("../pages/issues/listIssues/ListIssues"));
const EditIssues = lazy(() => import("../pages/issues/editIssues/EditIssues"));
const ViewIssues = lazy(() => import("../pages/issues/viewIssue/ViewIssue"));
const ListCinc = lazy(() => import("../pages/cinc/listCinc/ListCinc"));
const EditCinc = lazy(() => import("../pages/cinc/editCinc/EditCinc"));
const ViewCinc = lazy(() => import("../pages/cinc/viewCinc/ViewCinc"));
const ListGallery = lazy(() =>
  import("../pages/gallery/listGallery/ListGallery")
);

const Layout = () => {
  return (
    <div className="container">
      <Sidebar />
      <div className="mainContent">
        <Navbar />
        <Outlet />
      </div>
    </div>
  );
};

const GuardedRoute = (drawerData) => {
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page

  return isAuthenticated() ? <Layout /> : <Navigate to={RoutesPath.LOGIN} />;
};

export const RoutesElements = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
    exact: true,
    errorElement: <ErrorElement />,
  },
  {
    path: RoutesPath.HOME,
    element: <GuardedRoute />,
    exact: true,

    children: [
      {
        element: <Dashboard />,
        index: true,
      },
      {
        path: RoutesPath.USER,
        element: <ListUsers />,
      },
      {
        path: RoutesPath.USER_EDIT + ":id",
        element: <EditUser />,
      },
      {
        path: RoutesPath.USER_VIEW + ":id",
        element: <ViewUser />,
      },
      {
        path: RoutesPath.EVENT,
        element: <ListCinc />,
      },
      {
        path: RoutesPath.EVENT_EDIT + ":id",
        element: <EditCinc />,
      },
      {
        path: RoutesPath.EVENT_VIEW + ":id",
        element: <ViewCinc />,
      },
      {
        path: RoutesPath.GALLERY,
        element: <ListGallery />,
      },
      {
        path: RoutesPath.GALLERY_VIEW + ":id",
        element: <ViewGallery />,
      },
      {
        path: RoutesPath.REPORT_ISSUE,
        element: <ListIssues />,
      },
      {
        path: RoutesPath.REPORT_ISSUE_VIEW + ":id",
        element: <ViewIssues />,
      },
      {
        path: RoutesPath.REPORT_ISSUE_EDIT + ":id",
        element: <EditIssues />,
      },
      {
        path: RoutesPath.GALLERY,
        element: <div>gallary</div>,
      },
    ],
  },
]);
